export default __webpack_public_path__ + "static/media/insider_base.84effbf4.jpeg";